<template>
  <b-card>
    <div class="min-h-[80vh]">
      <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-3 md:mb-0">
        <div class="font-semibold text-2xl leading-none tracking-normal align-middle">
          AI Customer Service
        </div>
        <div class="flex flex-wrap md:flex-nowrap gap-2 items-center">
          <div>
            <div class="border-2 w-fit px-1 py-[0.5rem] border-[#E2E2E2] flex gap-2 items-center rounded-lg ">
              <div>
                <img src="https://storage.googleapis.com/komerce/assets/LP-Komchat/customer service.svg">
              </div>
              <div class="text-lg">
                <span class="font-semibold">{{ agentList.length }}</span>/2
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="border-2 w-fit px-1 py-[0.5rem] border-[#E2E2E2] flex gap-2 items-center rounded-l-lg">
              <img
                class="w-[20px] h-[20px]"
                src="https://storage.googleapis.com/komerce/assets/LP-Komchat/Group 38296.png"
              >
              <div class="text-lg flex gap-1">
                <span class="mr-4">{{ IDR(balance) }}
                  <b-icon
                    v-if="Number(balance) <= 5000 && Number(balance) >= 500"
                    v-b-popover.hover.bottom="'Coin kamu menipis. Segera Top Up agar tetap aktif.'"
                    class="text-[#FBA63C]"
                    icon="exclamation-triangle-fill"
                  />
                  <b-icon
                    v-if="Number(balance) < 500"
                    v-b-popover.hover.bottom="'Coin kamu habis. Top Up untuk menggunakan fitur CS AI.'"
                    class="text-danger"
                    icon="exclamation-circle-fill"
                  />
                </span>
              </div>
            </div>
            <div
              role="button"
              class="border flex items-center px-1 py-[0.5rem] bg-[#E2E2E2]"
              @click="$bvModal.show('modal-top-up-komchat-coin')"
            >
              <b-icon
                class="text-black"
                scale="1.5"
                icon="plus-circle"
              />
            </div>
            <div
              role="button"
              class="border flex items-center px-1 p-[0.5rem] bg-[#E2E2E2] rounded-r-lg"
              @click="$router.push('/komchat-coins')"
            >
              <b-icon
                class="text-black"
                scale="1.5"
                icon="clock-history"
              />
            </div>
          </div>
          <div>
            <b-button
              variant="primary"
              :disabled="isLoadingCreate || agentList.length >= 2"
              @click="addAgent()"
            >
              <div>
                <b-icon
                  v-if="isLoadingCreate"
                  icon="arrow-clockwise"
                  animation="spin"
                />
                <b-icon
                  v-else
                  class="mr-1"
                  icon="plus"
                  scale="1.3"
                />
                <span>Tambah AI Customer Service</span>
              </div>
            </b-button>
          </div>
        </div>
      </div>
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <div
          v-show="!agentList.length && !isLoading"
          class="mt-3 grid justify-center"
        >
          <b-img
            center
            class="mt-3 mb-2"
            src="https://storage.googleapis.com/komerce/assets/LP-Komchat/icon-ai-komchat-ai.svg"
            alt="AI Customer Service"
          />
          <div class="font-poppins font-normal text-black mb-1 leading-none tracking-normal text-center align-middle">
            Kamu belum memiliki AI Customer Service
          </div>
          <div class="font-poppins font-normal text-sm leading-none tracking-normal text-center align-middle">
            Yuk, buat AI Customer Service pertama kamu!
          </div>
        </div>
        <div class=" mt-2 p-1">
          <CardCsAi
            :data-agent="agentList"
            :balance="balance"
            @refresh="getAgentList"
          />
        </div>
      </b-overlay>
    </div>
    <ModalCheckCsAi
      :product-list-empty="isProductEmpty"
      :whats-app-cs-ai-empty="isWhatsAppCsAiEmpty"
      :payment-was-set="isPaymentWasSet"
    />
    <ModalValidationAccessBroadcast
      :is-expired="isExpiredPackage"
      :context="'customer_service'"
    />
    <ModalTopUp
      @refreshSaldo="getBalance"
      @handleTopupWithQris="handleTopupWithQris"
    />
    <ScanQRIS
      :qr-bill-detail="dataQris"
      :is-custom="true"
      @paymentSuccess="handlePaymentSuccess"
    />
    <ModalKomchatCoinRemaining
      :balance="balance"
      :type="modalType"
      :closing-count="closingCount"
      @topup="handleTopup"
      @lanjut="handleLanjut"
      @kembali="handleKembali"
    />
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { IDR } from '@/libs/currency'
import CardCsAi from './Ai/CardCsAi.vue'
import ModalCheckCsAi from './modal/ModalCheckCsAi.vue'
import { apiGetAgentList, apiActivateAgent } from './Ai/service/api.agent.service'
import ModalValidationAccessBroadcast from './Broadcast/components/ModalValidationAccessBroadcast.vue'
import apiGetBalance from './Broadcast/service/api.balance.service'
import ModalTopUp from './Broadcast/components/ModalTopUp.vue'
import ScanQRIS from '../dashboard/modal/ScanQRIS.vue'
import ModalKomchatCoinRemaining from './modal/ModalKomchatCoinRemaining.vue'

export default {
  name: 'AiCustomerService',
  components: {
    CardCsAi,
    ModalCheckCsAi,
    ModalValidationAccessBroadcast,
    ModalTopUp,
    ScanQRIS,
    ModalKomchatCoinRemaining,
  },

  data() {
    return {
      agentList: [],
      isLoading: false,
      isLoadingCreate: false,
      isWhatsAppCsAiEmpty: false,
      isProductEmpty: false,
      isPaymentWasSet: false,
      balance: 0,
      dataQris: {},
      modalType: 'warning',
      closingCount: 0,
      IDR,
    }
  },
  computed: {
    ...mapState('komchat', ['whatsAppList', 'productList', 'paymentInterface']),
    ...mapState('whatsapp', {
      dashboardWa: state => state.dashboard_wa || {},
    }),

    isExpiredPackage() {
      return this.dashboardWa.whatsapp_expired_at === 0
    },
    komchatLevelPackage() {
      return this.dashboardWa.subscription_plan_level
    },
  },
  async mounted() {
    this.checkExpiredPackage()
    await this.getBalance()
    await this.getAgentList()
  },
  methods: {
    handlePaymentSuccess(message) {
      this.$bvModal.hide('scanQris')
      this.getBalance()
      this.$toast_success({ message })
    },
    handleTopupWithQris(data) {
      this.dataQris = data
      this.$bvModal.show('scanQris')
    },
    handleTopup() {
      this.$bvModal.hide('modal-komchat-coin-remaining')
      this.$bvModal.show('modal-top-up-komchat-coin')
    },
    handleLanjut() {
      this.$bvModal.hide('modal-komchat-coin-remaining')
    },
    handleKembali() {
      this.$bvModal.hide('modal-komchat-coin-remaining')
    },
    async checkAccess() {
      try {
        await this.$store.dispatch('komchat/getWhatsAppList')
        await this.$store.dispatch('komchat/getProductList')
        await this.$store.dispatch('komchat/getPaymentInterface')
      } catch (error) {
        this.$toast_error({ message: 'Gagal memuat data. Silakan coba lagi.' })
      }
    },
    async addAgent() {
      this.isLoadingCreate = true
      try {
        await this.checkAccess()
        await this.getBalance()

        if (Number(this.balance) < 500) {
          this.modalType = 'insufficient'
          this.$bvModal.show('modal-komchat-coin-remaining')
          return
        }

        const whatsAppCsAi = this.whatsAppList ? this.whatsAppList?.filter(item => item.type === 'komchat_ai') : []

        this.isProductEmpty = !this.productList?.length
        this.isWhatsAppCsAiEmpty = !whatsAppCsAi?.length
        this.isPaymentWasSet = !this.paymentInterface?.color

        if (this.isProductEmpty || this.isWhatsAppCsAiEmpty || this.isPaymentWasSet) {
          this.$bvModal.show('modal-check-before-create-cs-ai')
        } else {
          this.$router.push({ name: 'create-ai-customer-service' })
        }
      } catch (error) {
        this.$toast_error({ message: 'Gagal menambahkan agent' })
      } finally {
        this.isLoadingCreate = false
      }
    },
    async getBalance() {
      try {
        const { data } = await apiGetBalance()
        this.balance = data.data.balance
        if (Number(this.balance) < 500) {
          this.modalType = 'insufficient'
          this.$bvModal.show('modal-komchat-coin-remaining')
          return
        }
        if (Number(this.balance) <= 5000 && Number(this.balance) >= 500) {
          this.modalType = 'warning'
          this.closingCount = Math.floor(Number(this.balance) / 500)
          this.$bvModal.show('modal-komchat-coin-remaining')
          return
        }
      } catch {
        this.toast_error({ message: 'Gagal mendapatkan data saldo' })
      }
    },
    async getAgentList() {
      this.isLoading = true
      try {
        const { data } = await apiGetAgentList()
        this.agentList = data?.data || []

        if (Number(this.balance) <= 0) {
          const activeAgents = this.agentList.filter(agent => agent.is_active)
          if (activeAgents.length > 0) {
            try {
              await Promise.all(activeAgents.map(agent => apiActivateAgent(agent.id, false)))
              this.agentList = this.agentList.map(agent => ({
                ...agent,
                is_active: false,
              }))
            } catch (err) {
              console.error('Failed to auto-deactivate agents', err)
            }
          }
        }
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data CS AI' })
      } finally {
        this.isLoading = false
      }
    },
    async checkExpiredPackage() {
      try {
        await this.$store.dispatch('whatsapp/getUpdateDashboardWa')
        if (this.isExpiredPackage || this.komchatLevelPackage < 2) {
          this.$bvModal.show('modal-validation-access-broadcast')
        }
      } catch (error) {
        this.$toast_error({ message: 'Gagal memeriksa status paket' })
      }
    },
  },
}
</script>
